import { formatCreatedAt } from '@/services/utils';

export const normalizeBeneficiaryForModal = (beneficiaryOrder) => {
	const user = beneficiaryOrder?.user || {};

	return {
		...user,
		id: user.id,
		companyName: user.companyName || beneficiaryOrder?.companyName || '',
		plan: user.plan || beneficiaryOrder?.product_name || '',
		createdAt: beneficiaryOrder?.createdAt || user.createdAt || '',
	};
};

export const normalizeDependentForModal = (dependent, titularOrder) => {
	const titularUser = titularOrder?.user || {};

	return {
		...dependent,
		id: dependent?.id,
		companyName: dependent?.companyName || titularUser.companyName || titularOrder?.companyName || '',
		plan: dependent?.plan || titularUser.plan || titularOrder?.product_name || '',
		createdAt: dependent?.createdAt || titularOrder?.createdAt || '',
	};
};

const COMPANY_USER_UPDATE_FIELDS = [
	'name',
	'email',
	'gender',
	'birthday',
	'phone',
	'phone_code',
	'address',
	'zipCode',
	'number',
	'complemento',
	'state',
	'city',
	'neightboorhood',
];

const buildCompanyUserUpdatePayload = (data, { isTitular = false } = {}) => {
	const payload = COMPANY_USER_UPDATE_FIELDS.reduce((acc, field) => {
		if (data[field] !== undefined) {
			acc[field] = data[field];
		}
		return acc;
	}, {});

	if (payload.phone) {
		payload.phone = String(payload.phone).replace(/\D/g, '').slice(-9);
	}

	if (isTitular && (payload.complemento == null || payload.complemento === '')) {
		payload.complemento = ' ';
	}

	return payload;
};

export const buildBeneficiaryUpdatePayload = (data) =>
	buildCompanyUserUpdatePayload(data, { isTitular: true });

export const buildDependentUpdatePayload = (data) =>
	buildCompanyUserUpdatePayload(data, { isTitular: false });

export const buildUserUpdatePayload = (data) =>
	buildCompanyUserUpdatePayload(data, { isTitular: false });

export const formatLastLogin = (value) => {
	if (value == null || value === '') return 'Nunca logou';
	return formatCreatedAt(value);
};
